import dayjs, { ConfigType } from "dayjs";
import utc from "dayjs/plugin/utc";
import { t } from "i18next";

dayjs.extend(utc);

const isValidDate = (d: ConfigType): boolean => dayjs(d).isValid();

function validateDate(date: ConfigType, template: string): Date | undefined {
  if (!date || !isValidDate(date)) return undefined;
  return dayjs(date).utc().format(template) as unknown as Date;
}

const formatDate = (date: ConfigType) => validateDate(date, "DD/MM/YYYY");
const formatDateTime = (date: ConfigType) =>
  validateDate(date, "DD/MM/YYYY, HH:mm");
const formatDateFilter = (date: ConfigType) => validateDate(date, "DD/MM/YY");
const formatDateFilterSil = (date: ConfigType) =>
  validateDate(date, "YYYY-MM-DD");

const formaterDateHuman = (date: string): string => {
  const mois: string[] = [
    t("janvier"),
    t("fevrier"),
    t("mars"),
    t("avril"),
    t("mai"),
    t("juin"),
    t("juillet"),
    t("aout"),
    t("septembre"),
    t("octobre"),
    t("novembre"),
    t("decembre"),
  ];
  const [annee, moisNum, jour, heure, minute, seconde]: number[] = date
    .split(/[-T:.Z]/)
    .map(Number);
  const moisTexte: string = mois[moisNum - 1];
  return `${jour} ${moisTexte} ${annee}, ${heure}:${minute}:${seconde}`;
};

const getMaxBirthDate = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  return today.toISOString().split("T")[0];
};

/** Date du jour au format YYYY-MM-DD (fuseau local, pour inputs type="date"). */
const getTodayLocalIsoDate = (): string => dayjs().format("YYYY-MM-DD");

/** Horodatage local pour un input `type="datetime-local"` (YYYY-MM-DDTHH:mm). */
const toDatetimeLocalInput = (date: ConfigType = new Date()): string =>
  dayjs(date).format("YYYY-MM-DDTHH:mm");

/** Convertit une valeur `datetime-local` vers ISO 8601 UTC attendue par l'API. */
const datetimeLocalToIso = (value: string): string => {
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.toISOString() : value;
};

/** Convertit une date saisie (YYYY-MM-DD) vers le format API DD-MM-YYYY sans décalage UTC. */
const formatIsoDateInputToApi = (isoDate: string): string => {
  const parsed = dayjs(isoDate, "YYYY-MM-DD", true);
  if (!parsed.isValid()) {
    return isoDate;
  }
  return parsed.format("DD-MM-YYYY");
};

export {
  datetimeLocalToIso,
  formatDate,
  formatIsoDateInputToApi,
  getMaxBirthDate,
  getTodayLocalIsoDate,
  toDatetimeLocalInput,
  formatDateFilter,
  formatDateFilterSil,
  formatDateTime,
  formaterDateHuman,
};
